export default {
  subscription: 'מנוי',
  subscriptions: 'מנויים',
  'subscription.feature': 'פיצ׳ר',
  'subscription.features': 'פיצ׳רים',
  'subscription.select': 'בחר',
  'subscription.selected': 'נבחר',
  'subscription.title': 'כותרת',
  'subscription.duration': 'משך תשלום',
  'subscription.sale': 'פרטי מבצע',
  'subscription.saleStart': 'התחיל ב־',
  'subscription.saleEnd': 'פג תוקף ב־',
  'subscription.discount': 'הנחה',
  'subscription.discountInfo': 'הנחה {discount}',
  'subscription.info': 'פרטי מנוי',
  'subscription.price': 'מחיר',
  'subscription.notice': 'הודעה',
  'subscription.users': 'מקסימום משתמשי עסק',
  'subscription.usersInfo': 'עד {{users}} משתמשים',
  'subscription.actions.edit': 'ערוך מנויים',
  'subscription.actions.addNew': 'הוסף מנויים חדשים',
  'subscription.actions.manage': 'נהל מנויים',
  'subscription.msg.deleteConfirm': 'האם אתה בטוח שברצונך למחוק מנוי זה',
  'subscription.tags': 'תגיות',
  'subscription.assigned.features': 'פיצ׳רים מוקצים ({{count}})',
  'subscription.features.helper':
    'ליצירת מנוי, עליך להקצות לפחות פיצ׳ר אחד. פיצ׳רים מגדירים את היכולות הכלולות במנוי. בחר פיצ׳רים מהרשימה הזמינה או צור חדשים.',
  'subscription.msg.unAssignConfirm':
    'האם אתה בטוח שברצונך לבטל את הקצאת הפיצ׳ר הזה?',
  'subscription.msg.unAssignAllConfirm':
    'האם אתה בטוח שברצונך לבטל את כל הקצאות הפיצ׳רים?',
  'subscription.msg.deactivateBlocked': 'ההשבתה נחסמה',
  'subscription.msg.deactivateBlockedDescription':
    'אין אפשרות להשבית מנוי זה מכיוון שהוא נמצא בשימוש עבור {{tenantName}}.',
  'subscription.actions.navigateToTenant': 'נווט ללקוח',
};
